import { render, staticRenderFns } from "./EditarCRUD.vue?vue&type=template&id=bff29916&"
import script from "./EditarCRUD.vue?vue&type=script&lang=js&"
export * from "./EditarCRUD.vue?vue&type=script&lang=js&"
import style0 from "./EditarCRUD.vue?vue&type=style&index=0&id=bff29916&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports